/**
 * 전화번호 포맷팅 함수
 * @param {string} value - 포맷팅할 전화번호 문자열
 * @returns {string} - 포맷팅된 전화번호 문자열
 */
export const formatPhoneNumber = (value) => {
  // 숫자만 추출
  const numbers = value.replace(/\D/g, "");

  // 02로 시작하는 서울 지역번호 처리
  if (numbers.startsWith("02")) {
    // 최대 10자리로 제한 (02-XXXX-XXXX)
    const limitedNumber = numbers.slice(0, 10);

    // 자릿수에 따라 포맷팅
    if (limitedNumber.length <= 2) {
      return limitedNumber; // 02
    } else if (limitedNumber.length <= 6) {
      // 중간 번호가 3자리 또는 4자리일 수 있음
      return `${limitedNumber.slice(0, 2)}-${limitedNumber.slice(2)}`; // 02-XXX 또는 02-XXXX
    } else {
      // 총 길이에 따라 중간 번호 구분
      // 02-XXX-XXXX (총 9자리) 또는 02-XXXX-XXXX (총 10자리)
      const isShortFormat = limitedNumber.length <= 9;
      const middleDigits = isShortFormat ? 3 : 4;

      return `${limitedNumber.slice(0, 2)}-${limitedNumber.slice(2, 2 + middleDigits)}-${limitedNumber.slice(2 + middleDigits)}`;
    }
  }
  // 그 외 지역번호 또는 휴대폰 번호
  else if (numbers.length === 10) {
    // 10자리 번호는 000-000-0000 형식으로 처리
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}`;
  } else {
    // 최대 11자리로 제한 (XXX-XXXX-XXXX)
    const limitedNumber = numbers.slice(0, 11);

    // 자릿수에 따라 포맷팅
    if (limitedNumber.length <= 3) {
      return limitedNumber; // XXX
    } else if (limitedNumber.length <= 7) {
      return `${limitedNumber.slice(0, 3)}-${limitedNumber.slice(3)}`; // XXX-XXXX
    } else {
      return `${limitedNumber.slice(0, 3)}-${limitedNumber.slice(3, 7)}-${limitedNumber.slice(7)}`; // XXX-XXXX-XXXX
    }
  }
};
